import React, { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Backdrop, CircularProgress, Container } from "@mui/material";
import PaymentConfirmation from "../../components/PaymentConfirmation";
import { ApiCallStatus } from "../../utils/constants";
import { fetchPaymentData } from "../PageFunctions/paymentFunctions";
import {
	fetchOrderData,
	removeOrderCookies
} from "../PageFunctions/orderFunctions";
import { useCart } from "react-use-cart";
import { useArgusAuth } from "../../hooks/useArgusAuth";




const PaymentConfirmationPage = ({
	genericDataLoaded,
	genericPageContent
}) => {
	const {isAuthenticated, isLoading} = useArgusAuth();
	const {emptyCart} = useCart();
	const {paymentId} = useParams();
	const location = useLocation();
	const navigate = useNavigate();
	const [orderData, setOrderData] = useState(null);
	const [paymentData, setPaymentData] = useState(null);

	const [fetchPaymentDataCallStatus, setFetchPaymentDataCallStatus] = useState(ApiCallStatus.NotStarted);
	const [fetchOrderDataCallStatus, setFetchOrderDataCallStatus] = useState(ApiCallStatus.NotStarted);
	const [removeOrderCookiesCallStatus, setRemoveOrderCookiesCallStatus] = useState(ApiCallStatus.NotStarted);

	const gotoLoginPage = () => {
		return navigate("/login", {state: {from: location}});
	};

	const gotoHomePage = () => navigate("/");



	const fetchPaymentDataAsync = async () => {
		await fetchPaymentData({
			paymentId,
			setPaymentData,
			setStatusInProgress: () => setFetchPaymentDataCallStatus(ApiCallStatus.InProgress),
			setStatusSuccess: () => setFetchPaymentDataCallStatus(ApiCallStatus.Succeeded),
			setStatusFailed: () => setFetchPaymentDataCallStatus(ApiCallStatus.Failed),
			setStatusError: () => setFetchPaymentDataCallStatus(ApiCallStatus.Error)
		});
	};

	const fetchOrderDataAsync = async () => {
		await fetchOrderData({
			setOrderData,
			setStatusInProgress: () => setFetchOrderDataCallStatus(ApiCallStatus.InProgress),
			setStatusSuccess: () => setFetchOrderDataCallStatus(ApiCallStatus.Succeeded),
			setStatusFailed: () => setFetchOrderDataCallStatus(ApiCallStatus.Failed),
			setStatusError: () => setFetchOrderDataCallStatus(ApiCallStatus.Error)
		});
	};

	const removeOrderCookiesAsync = async () => {
		await removeOrderCookies({
			setStatusInProgress: () => setRemoveOrderCookiesCallStatus(ApiCallStatus.InProgress),
			setStatusSuccess: () => setRemoveOrderCookiesCallStatus(ApiCallStatus.Succeeded),
			setStatusFailed: () => setRemoveOrderCookiesCallStatus(ApiCallStatus.Failed),
			setStatusError: () => setRemoveOrderCookiesCallStatus(ApiCallStatus.Error)
		});
	};

	useEffect(() => {
		if (genericDataLoaded === true && isLoading === false) {
			if (isAuthenticated === false) {
				gotoLoginPage();
			} else {
				fetchPaymentDataAsync();
				fetchOrderDataAsync();
			}
		}
	}, [genericDataLoaded, isAuthenticated, isLoading]);

	useEffect(() => {
		if (removeOrderCookiesCallStatus === ApiCallStatus.Succeeded) {
			emptyCart();
			gotoHomePage();
		}
	}, [removeOrderCookiesCallStatus]);

	const allLoadingStates = [
		fetchPaymentDataCallStatus,
		fetchOrderDataCallStatus,
		removeOrderCookiesCallStatus
	];

	const pageIsLoading = allLoadingStates.includes(ApiCallStatus.InProgress) || genericDataLoaded === false || isLoading === true;

	return (
		<Container maxWidth="lg">
			<PaymentConfirmation
				paymentData={paymentData}
				orderData={orderData}
				handleCloseClick={removeOrderCookiesAsync}
			/>
			<Backdrop
				sx={{color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1}}
				open={pageIsLoading}
			>
				<CircularProgress color="inherit"/>
			</Backdrop>
		</Container>
	);
};
export default PaymentConfirmationPage;
